export default "__VITE_ASSET__70f90257__"